import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden hero-gradient"
    >
      {/* Soft floating accents for a subtle gradient pattern */}
      <div className="absolute -top-24 -left-24 w-[40rem] h-[40rem] rounded-full bg-gold/10 blur-3xl animate-float-blob pointer-events-none" />
      <div className="absolute -bottom-32 right-0 w-[44rem] h-[44rem] rounded-full bg-royal/10 blur-3xl animate-float-blob pointer-events-none" style={{ animationDelay: "4s" }} />

      {/* Thin gold rule top-right */}
      <div className="hidden lg:block absolute top-40 right-24 w-px h-40 bg-gradient-to-b from-gold/0 via-gold/50 to-gold/0" />

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-24 pt-32 pb-20 lg:py-0">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="flex items-center justify-center gap-4 mb-8"
          >
            <span className="h-px w-14 bg-gold" />
            <span className="font-accent text-sm uppercase tracking-[0.28em] text-gold">
              Real Estate · Investment · Development
            </span>
          </motion.div>

          <h1 className="font-display text-royal leading-[1.02] text-5xl md:text-7xl lg:text-8xl">
            {["Building a", "better future"].map((line, i) => (
              <span key={line} className="block overflow-hidden">
                <motion.span
                  className="block"
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.9, delay: 0.3 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
            <span className="block overflow-hidden">
              <motion.span
                className="block italic text-gold-gradient"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
              >
                through strategic impact.
              </motion.span>
            </span>
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.85 }}
            className="mt-8 max-w-2xl mx-auto text-lg md:text-xl text-royal/75 leading-relaxed"
          >
            Titanium Wealth USA unites three decades of expertise across real
            estate, manufacturing, and investment into refined developments
            engineered for enduring value.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="mt-10 flex flex-col sm:flex-row justify-center gap-4"
          >
            <a
              href="#projects"
              data-testid="hero-cta-projects"
              className="group inline-flex items-center justify-center gap-3 bg-royal text-beige-light font-accent uppercase tracking-[0.18em] text-sm px-9 py-4 hover:bg-gold transition-all duration-300"
            >
              Explore Projects
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-contact"
              className="inline-flex items-center justify-center gap-3 border border-royal/30 text-royal font-accent uppercase tracking-[0.18em] text-sm px-9 py-4 hover:border-gold hover:text-gold transition-all duration-300"
            >
              Partner With Us
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className="mt-14 flex items-center justify-center gap-3 text-royal/60"
          >
            <span className="font-accent text-sm uppercase tracking-[0.25em]">
              Headquarters — Orlando, Florida
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
